import type { SelectedReason } from './reasons';

export interface TransferAssignment {
  readonly worker_id: string;
  readonly user_id: string;
  readonly username: string;
  readonly first_name: string;
  readonly last_name: string;
}

export interface TransferRecipient {
  readonly id: string;
  readonly name: string;
  readonly role?: string;
  readonly caseCount?: number;
  readonly assignment?: TransferAssignment;
}

export interface TransferPayload {
  readonly recipient: {
    readonly id: string;
    readonly name: string;
    readonly assignment: TransferAssignment;
  };
  readonly reasons: readonly SelectedReason[];
  readonly note?: string;
  readonly caseContext?: string;
}

export class TransferNotSentError extends Error {
  readonly sent = false;

  constructor(message: string) {
    super(message);
    this.name = 'TransferNotSentError';
    Object.setPrototypeOf(this, TransferNotSentError.prototype);
  }
}

export type TransferPermission = 'loading' | 'allowed' | 'denied';

export interface TransferActionData {
  readonly currentUser?: { readonly displayName?: string };
  readonly initialRecipients?: readonly TransferRecipient[];
  readonly permission?: TransferPermission;
}
